export default __webpack_public_path__ + "static/stacked-bar-093874808f700c6636df1bff285b440b.png";